import '../styles/questionAdhd.css';


function QuestionNarcissism({ answer, index, onSelect, selected }) {
    const name = `narcissism-q${index}`;
    const idFalse = `narcissism-q${index}-false`;
    const idTrue = `narcissism-q${index}-true`;
    return (
        <div className="question">
            <div className="radio-container mobile-flex">
                <div className='radio-questions'>
                    <div className="radio-group">
                        <input
                        type="radio"
                        id={idFalse}
                        name={name}
                        value={0}
                        className="radio-input"
                        checked={selected === 0}
                        onChange={() => onSelect(0)}
                        />
                        <label htmlFor={idFalse} className="radio-label-narcissism">
                            {answer.answerFalse}
                        </label>
                    </div>
                    <div className="radio-group">
                        <input
                            type="radio"
                            id={idTrue}
                            name={name}
                            value={1}
                            className="radio-input-"
                            checked={selected === 1}
                            onChange={() => onSelect(1)}
                        />
                        <label htmlFor={idTrue} className="radio-label-narcissism">
                            {answer.answerTrue}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default QuestionNarcissism;